import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        m: -3,
        minHeight: 'calc(100vh - 64px)'
      }}
    >
      <Stack spacing={4} alignItems="center" textAlign="center" maxWidth="sm">
        <ErrorOutlineOutlinedIcon
          sx={{
            fontSize: 80,
            color: theme.palette.error.main,
            mb: 2
          }}
        />
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            mb: 1
          }}
        >
          {t('errors:pageNotFound')}
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{
            maxWidth: '400px',
            lineHeight: 1.6,
            mb: 2
          }}
        >
          {t('errors:pageNotFoundDescription')}
        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          sx={{ mt: 3 }}
        >
          <Button
            variant="contained"
            startIcon={<ArrowBackIosNewIcon />}
            onClick={() => navigate(-1)}
            sx={{
              textTransform: 'none',
              px: 3,
              py: 1.5,
              borderRadius: 2,
              fontWeight: 500,
              minWidth: '140px'
            }}
          >
            {t('errors:generic.goBack')}
          </Button>
          <Button
            variant="outlined"
            startIcon={<HomeOutlinedIcon />}
            onClick={() => navigate('/')}
            sx={{
              textTransform: 'none',
              px: 3,
              py: 1.5,
              borderRadius: 2,
              fontWeight: 500,
              minWidth: '140px',
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              '&:hover': {
                borderColor: theme.palette.primary.dark,
                backgroundColor: theme.palette.primary.main + '08'
              }
            }}
          >
            {t('errors:generic.goHome')}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default NotFoundPage;
